import { CaipNudgeTriggerEvent } from "../../../../types/CaipNudgeTriggerEvent";
import { EditorActionKey } from "../../../actions/ActionKeys";
import { EditorAction } from "../../../actions/editor";

/** The current CAIP nudge trigger event. */
export const caipNudgeTriggerEvent = (
  state: CaipNudgeTriggerEvent | null = null,
  action: EditorAction
): CaipNudgeTriggerEvent | null => {
  switch (action.type) {
    case EditorActionKey.SET_EDITOR_CAIP_NUDGE_TRIGGER_EVENT:
      return action.payload.trigger;
    default:
      return state;
  }
};
